<template>
  <div class="location-disabled-modal container">
    <div class="row text-heading text-24"
         align="center">
      <div class="col">
          {{$t('title')}}
      </div>
    </div>

    <div class="row spacing-5">
      <div class="col">
        {{$t('intro')}}
      </div>
    </div>

    <div class="row spacing-4"
         align="center">
      <div class="col">
        <inline-svg class="icon--location"
          src="LocationConfirmIcon">
        </inline-svg>
      </div>
    </div>

    <div class="row spacing-3"
         align="left">
      <div class="col">
        {{$t('body')}}
      </div>
    </div>

    <div v-if="!isCcfiBrand"
         class="row spacing-3">
      <div class="col">
        {{$t('footer')}}
      </div>
    </div>

    <div v-if="!isCcfiBrand || isSkipCcfiFlow"
         class="row spacing-4"
         align="center">
      <div class="col">
        <button id="scheduleAppointmentButton"
                class="btn button--primary"
                type="button"
                @click="scheduleAppointment">
          {{$t('appointmentButton')}}
        </button>
      </div>
    </div>

    <div class="row spacing-4"
         align="center">
      <div class="col">
        <a class="text-link"
           tabindex="0"
           role="link"
           @click="tryAgain">
          {{$t('tryAgainButton')}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// Elements
import InlineSvg from '../../common/elements/InlineSvg.vue'

// Services
import { EventBus } from '../../../services/eventBusService.js'

// Utilities
import Logger from '../../../utility/loggerUtil'
import { KeyConstants, MenuButtonEnum } from '../../../constants'
import { mapGetters } from 'vuex'

export default {
  name: 'location-disabled-modal',

  components: {
    InlineSvg
  },

  beforeCreate () {
    this.$store.commit('display/updateHeader', { buttonType: MenuButtonEnum.menu })
  },

  data () {
    return {
      id: KeyConstants.modals.locationDisabled
    }
  },

  computed: {
    ...mapGetters('applicationSession', ['isCcfiBrand', 'isSkipCcfiFlow'])
  },

  methods: {
    scheduleAppointment () {
      this.$emit('close', ({ routerObject: { name: 'ScheduleAppointment', params: { hideOnlineAppraisal: true } } }))
    },

    async tryAgain () {
      this.$wait.start('submit')
      try {
        this.$emit('close')

        EventBus.$emit(KeyConstants.gpsDisabledEvent)
      } catch (error) {
        Logger.error('Failed to get location')
        Logger.debug(error)
      } finally {
        this.$wait.end('submit')
      }
    }
  }
}
</script>

<style scoped>
.icon--location {
  width: 6.5rem;
}
</style>

<i18n>
{
  "en": {
    "title": "Location Disabled",
    "intro": "Uh-Oh! We are unable to continue because we do not have access to your location.",
    "body": "No worries, you can enable your location permissions in your browser settings.",
    "footer": "Or visit us at a store and we'll be happy to assist you.",
    "appointmentButton": "Make an Appointment",
    "tryAgainButton": "I Updated My Location Permissions"
  }
}
</i18n>
